export const fr = {
  landingPageForNonprofits: {
    nonprofitHero: {
      title: {
        structure: "prefix_suffix_heading", // indicates word order
        prefix: "Trouvez votre prochain",
        suffix: "bénévole"
      },
      description: "Accédez gratuitement à un réseau de milliers de bénévoles d'entreprise talentueux",
      gallery: {
        alt: "Galerie d'activités bénévoles"
      }
    },
    nonprofitLogoGrid: {
      description: "Rejoignez d'autres organismes à but non lucratif qui veulent changer le monde pour le mieux",
      logos: {
        happyHerd: "Logo de The Happy Herd",
        dressForSuccess: "Logo de Dress for Success",
        makeAWish: "Logo de Make-A-Wish",
        ywca: "Logo de YWCA Metro Vancouver",
        quest: "Logo de Quest",
        jericho: "Logo de Jericho Stewardship Group"
      }
    },
    features: {
      item1: {
        title: "Atteignez des milliers de bénévoles d'entreprise",
        paragraph1: "Des employés du monde entier veulent vous aider dans vos projets d'une journée. De la peinture au jardinage, en passant par le nettoyage et la cuisine, nous sommes prêts à tout faire !"
      },
      buttons: {
        getInTouch: "Contactez-nous aujourd'hui",
        getStarted: "Commencez aujourd'hui"
      }
    },
    caseStudies: {
      title: "Études de cas",
      description: "Découvrez notre travail avec des organisations à but non lucratif qui ont un impact",
      viewMore: "Voir plus"
    },
    stats: {
      title: "Les organisations qui travaillent avec nous ont vu des résultats incroyables",
      description: "Nous aidons les organisations à but non lucratif à se connecter avec des entreprises locales pour réaliser des projets significatifs. C'est amusant, gratifiant et surtout, impactant !",
      items: {
        volunteerHours: {
          title: "Heures de bénévolat",
          description: "Lorsque les gens font du bénévolat pour de bonnes causes, les heures s'accumulent rapidement."
        },
        volunteers: {
          title: "Bénévoles",
          description: "Il y a eu plus de {count} inscriptions pour des opportunités de bénévolat provenant de plus d'une douzaine d'entreprises !"
        },
        impact: {
          title: "Impact financier",
          description: "Le bénévolat est évalué à 32 $ de l'heure — cela signifie que nos bénévoles ont un montant équivalent de plus de {amount}."
        }
      }
    }
  }
}